export default __webpack_public_path__ + "static/media/flips_book_2019_1.ea67d90f.png";